import { render, staticRenderFns } from "./CopasstTable.vue?vue&type=template&id=8b62d9ac&"
import script from "./CopasstTable.vue?vue&type=script&lang=js&"
export * from "./CopasstTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports